var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-8 mx-2 w-full"},[_c('ul',_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:tab.title,staticClass:"pt-4 mr-4 inline-block cursor-pointer font-normal",class:[
        index == _vm.selectedIndex
          ? 'border-b-4 border-gray-800 text-gray-800 color-gray-800 dark:border-white dark:color-white dark:text-white'
          : 'text-gray-800 dark:text-white'
      ],on:{"click":function($event){return _vm.selectTab(index)}}},[_vm._v(" "+_vm._s(tab.title)+" ")])}),0),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }